import { SimpleGrid } from "@chakra-ui/react";
import { FaFile } from "react-icons/fa";
import { AdminBox } from "../../../components/templates/Widget/AdminBox";
import { InternalHeader } from "../../../components/templates/InternalHeader";

export function ConfigPricingAdminPage() {
  return (
    <>
      <InternalHeader
        title="Configurações Precificação"
        has_filter={false}
        has_back_button={true}
      />
      <SimpleGrid columns={{ base: 1, md: 2 }} spacingX={2}>
        <AdminBox
          bg="blue.350"
          color="white"
          icon={FaFile}
          link="/precificacao/categoria-mercadoria"
          title="Categoria Mercadoria"
        />
        <AdminBox
          bg="blue.350"
          color="white"
          icon={FaFile}
          link="/precificacao/categoria-produto-venda"
          title="Categoria Produto de Venda"
        />
        <AdminBox
          bg="blue.350"
          color="white"
          icon={FaFile}
          link="/precificacao/mercadoria"
          title="Mercadoria"
        />
        <AdminBox
          bg="blue.350"
          color="white"
          icon={FaFile}
          link="/precificacao/subcategoria-mercadoria"
          title="Subcategoria Mercadoria"
        />
        <AdminBox
          bg="blue.350"
          color="white"
          icon={FaFile}
          link="/precificacao/produtos"
          title="Produtos de Ficha Técnica"
        />
      </SimpleGrid>
    </>
  );
}
